import React, { ReactElement } from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { PageHeaderComposition } from '@csv/styleguide/src/features/page-header/page-header';
import Section from '@csv/styleguide/src/elements/section/section';
import Container from '@csv/styleguide/src/elements/container/container';
import { Link } from 'gatsby';

function PracticeTablePage(): ReactElement {
  return (
    <Layout>
      <SEO
        title="Trainingstijden"
        description="Overzicht van alle trainingen van alle CSV-teams."
      />
      <PageHeaderComposition
        title="Trainingstijden"
        byline="Trainingsschema's van alle CSV-teams."
      />
      <Container>
        <Section>
          <p>
            Je vindt de trainingstijden tijdelijk op de volgende pagina:
            <Link to="/nieuws/nieuwe-trainingstijden-26-27">
              Trainingstijden 2026-2027
            </Link>
          </p>
        </Section>
      </Container>
    </Layout>
  );
}

export default PracticeTablePage;
